import localStore from "@/global/store/local-store";
import { StdResponse, request } from "@/global/config/request";

export function saveLayer(data: any, params?: {}): Promise<StdResponse<any>> {
    const projectUuid = localStore.projectId;
    return request.post(`/projects/${projectUuid}/layers`, data, {
        params: {
            ...params,
        }
    })
}

export function findLayersInProjectUuid(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectUuid}/layers`, {
        params: {
            ...params,
        }
    })
}


export function deleteLayer(layerUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/layers/${layerUuid}`, {
        params: {
            ...params,
        }
    })
}
export function updateLayer(data: any, params?: {}): Promise<StdResponse<any>> {
    const projectUuid = localStore.projectId;
    return request.put(`/projects/${projectUuid}/layers`, data, {
        params: {
            ...params,
        }
    })
}
